import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    interval: { type: Number, default: 9000 }
  }

  connect() {
    this.currentIndex = 0
    this.showSlide(this.currentIndex, true)
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.stopTimer()
    if (this.intervalValue > 0 && this.slideTargets.length > 1) {
      this.timer = setInterval(() => {
        this.showSlide(this.currentIndex + 1)
      }, this.intervalValue)
    }
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  showSlide(index, initial = false) {
    const total = this.slideTargets.length
    if (total === 0) return

    const targetIndex = (index + total) % total
    this.slideTargets.forEach((slide, idx) => {
      if (idx === targetIndex) {
        slide.classList.add("opacity-100", "pointer-events-auto", "z-0")
        slide.classList.remove("opacity-0", "pointer-events-none", "-z-10")
      } else {
        slide.classList.add("opacity-0", "pointer-events-none", "-z-10")
        slide.classList.remove("opacity-100", "pointer-events-auto", "z-0")
      }
    })

    this.indicatorTargets.forEach((indicator, idx) => {
      if (idx === targetIndex) {
        indicator.classList.add("bg-white")
        indicator.classList.remove("bg-transparent")
      } else {
        indicator.classList.remove("bg-white")
        indicator.classList.add("bg-transparent")
      }
    })

    this.currentIndex = targetIndex
    if (!initial) {
      this.startTimer()
    }
  }

  next() {
    this.showSlide(this.currentIndex + 1)
  }

  go(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (!Number.isNaN(index)) {
      this.showSlide(index)
    }
  }
}
